import Focus from './Focus';

export default {
	setupModals() {
		setupModals();
	},
	closeModals() {
		closeModals();
	},
	modalClose($modal) {
		closeModal($modal);
	},
	modalOpen($modal) {
		openModal($modal);
	},
	hasOpenModal() {
		return $('html body').hasClass('modal-open');
	}
}

let $anchors,
	$body,
	animSpeed = 300;

function setupModals() {
	$anchors = $('a.open-modal');

	$body    = $('body');

	if ($anchors.length > 0) {
		$anchors.each((index, item) => {
			let $anchor = $(item);

			if (!$anchor.hasClass('modals-setup')) {
				attachHandlers($anchor);
			}
		});

		$(document).on('keydown', (e) => {
			if (e.key === 'Escape') {
				closeModals();
			}
		});
	}
}

function attachHandlers($anchor) {
	let $modal = $('html ' + $anchor.attr('href'));

	$anchor.on('click', {modal : $modal}, openModalEvent);

	$anchor.addClass('modals-setup');

	$modal.find('a.close-modal').on('click', {modal : $modal}, closeModalEvent);
	$body.find('.site-overlay').on('click', closeModals);

	$anchor.trigger('attached-modal-handlers');
}

function openModalEvent(e) {
	$body.addClass('modal-open');

	let focusTrap = Focus.trapFocus(e.data.modal.get(0));

	e.data.modal.trigger('modal-opening', {modal : e.data.modal, focusTrap : focusTrap});

	e.data.modal.fadeIn(animSpeed);

	setTimeout(() => {
		e.data.modal.trigger('modal-open', {modal : e.data.modal});
	}, animSpeed);

	e.preventDefault();
}

function closeModalEvent(e) {
	if (!$body.hasClass('modal-open')) {
		return;
	}

	$body.removeClass('modal-open');

	e.data.modal.trigger('modal-closing', {modal : e.data.modal});

	e.data.modal.fadeOut(animSpeed);

	setTimeout(() => {
		e.data.modal.trigger('modal-closed', {modal : e.data.modal});
	}, animSpeed);

	e.preventDefault();
}

function closeModals(e) {
	if (!$body.hasClass('modal-open')) {
		return;
	}

	let $modals = $('.mint-modal');

	$modals.each((index, item) => {
		closeModal($(item), false);
	});

	$body.removeClass('modal-open');

	if (e) {
		e.preventDefault();
	}
}

function openModal($modal) {
	$body.addClass('modal-open');

	Focus.trapFocus($modal.get(0));

	$modal.find('a.close-modal').on('click', {modal : $modal}, closeModalEvent);
	$body.find('.site-overlay').on('click', closeModals);

	$modal.trigger('modal-opening', {modal : $modal});
	$modal.fadeIn(animSpeed);
	setTimeout(() => {
		$modal.trigger('modal-open', {modal : $modal});
	}, animSpeed);
}

function closeModal($modal, removeBodyClass = true) {
	if (!$body.hasClass('modal-open')) {
		return;
	}

	if (removeBodyClass) {
		$body.removeClass('modal-open');
	}

	$modal.trigger('modal-closing', {modal : $modal});
	$modal.fadeOut(animSpeed);

	setTimeout(() => {
		$modal.trigger('modal-closed');
	}, animSpeed);
}
